import React from 'react';
import PropTypes from 'prop-types';
import BaseModal from '../../../../components/BaseModal';

const ModalChangeWidgetRules = ({ visible, onHide, onClick }) => {
  return (
    <BaseModal
      title="Changer de widget"
      visible={visible}
      onHide={onHide}
      onClick={onClick}
    >
      <p>Si vous acceptez ce changement de widget, seulement les règles liées aux variables globales seront prises en compte.</p>
    </BaseModal>
  );
};

ModalChangeWidgetRules.propTypes = {
  visible: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired
};

export default ModalChangeWidgetRules;
